export function urlParser(url) {
	const params = new Proxy(new URLSearchParams(url.split('?')[1]), {
		get: (searchParams, prop) => searchParams.get(prop),
	})

	return { params }
}
